export default __webpack_public_path__ + "static/media/printerIcon.beef3d60.svg";